import request from 'services/axios';

export const postWanted = async (payload: postWantedPayload) => {
  const {data} = await request.post(`/api/v2/market/quality_expert_request`, {
    ...payload,
  });
  return data;
};
